/* 🤖 this file was generated by svg-to-ts */
export const siriusTimerDuotone: {
  name: 'timer_duotone';
  data: string;
} = {
  name: 'timer_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M12 20.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5Z" fill="currentColor"/><path d="M12 3a9 9 0 1 0 9 9 9.019 9.019 0 0 0-9-9Zm0 16.5a7.5 7.5 0 1 1 7.5-7.5 7.51 7.51 0 0 1-7.5 7.5Z" fill="currentColor"/><path d="m15.178 7.753-3.712 3.713a.76.76 0 0 0 0 1.068.769.769 0 0 0 1.068 0l3.713-3.712a.759.759 0 1 0-1.069-1.069ZM9.75 1.5h4.5a.75.75 0 1 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5Z" fill="currentColor"/></svg>`
};
